import * as types from './actions';
import APIUtil from '../config/APIUtil';
import UrlConstants from '../config/UrlConstants';
import * as code from '../config/Constants';


/**
 * @desc api call for update stripe settings
 * @param {*} data 
 */
 export function updatePlanSettingsAction(data) {
    let url = UrlConstants.planSettingUrl 
    return function (dispatch) {
        return APIUtil.putMethod(url,data,true).then(response => {
            if (response.status === code.OK) {
                dispatch({
                    type: types.UPDATE_PLAN_SETTING,
                    updatedPlanSettings : response.data
                });
            }
            else {
                dispatch({
                    type: types.UPDATE_PLAN_SETTING,
                    updatedPlanSettings: {}
                });
            }
            return response;
        });       
    }
}

/**
 * 
 * @desc Get subscription provider
 */

 export function getPlanProviderAction() {

    return function (dispatch) {
        return APIUtil.getMethod(UrlConstants.subscriptionProvider, false).then(response => {
           
            if (response) {
                dispatch({
                    type: types.SUBSCRIPTION_PROVIDER,
                    planProvider: response.data
                });
            }
            else {
                dispatch({
                    type: types.SUBSCRIPTION_PROVIDER,
                    planProvider: []
                });
            }
            return response;
        });
    }
}


/**
 * @desc api call for update stripe provider
 * @param {*} data 
 */
 export function updatePlanProviderAction(data) {
    let url = UrlConstants.updateProvider 
    return function (dispatch) {
        return APIUtil.putMethod(url,data,true).then(response => {
            if (response.status === code.OK) {
                dispatch({
                    type: types.UPDATE_PLAN_PROVIDER,
                    updatedPlanProvider : response.data
                });
            }
            else {
                dispatch({
                    type: types.UPDATE_PLAN_PROVIDER,
                    updatedPlanProvider: {}
                });
            }
            return response;
        });       
    }
}